function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, hidden) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          hidden
        }, {
          'gdpr-banner-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'gdpr-banner-text': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(`Mixpanel uses cookies to make it easier for you to use our website; read more about our `);
          __jade_nodes = __jade_nodes.concat(h("a", {
            "attrs": __vjadeStringifyAttrsIfObj({
              href: 'https://mixpanel.com/legal/privacy-policy'
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("cookie policy");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(`. We will also collect personal information about you as described in our `);
          __jade_nodes = __jade_nodes.concat(h("a", {
            "attrs": __vjadeStringifyAttrsIfObj({
              href: 'https://mixpanel.com/legal/privacy-policy'
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("privacy statement");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(`. By using our services you agree to the use of cookies and to the collection of your personal information.`);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("button", {
          "on": {
            click: $helpers.onAccept
          },
          "class": {
            'gdpr-banner-accept': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("I agree");;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("button", {
          "on": {
            click: $helpers.onDismiss
          },
          "class": {
            'gdpr-banner-dismiss': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'svg-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h('div', {
              props: {
                innerHTML: '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.76 15.24l8.48-8.48m0 8.48L6.76 6.76"/></svg>'
              }
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "hidden" in locals ? locals.hidden : typeof hidden !== "undefined" ? hidden : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;